import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.AppPricesRestService
 *
 * @description
 * This class contains methods used to retrieve information about product prices
 * using http requests.
 */
export default class AppPricesRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
    * @ngdoc function
    * @name rest.services.AppPricesRestService#getByAppId
    * @methodOf rest.services.AppPricesRestService
    * @function
    *
    * @description
    * Retrieves product prices.
    *
    * @returns {Promise} The promise of the call.
    */
    getByAppId(appId) {

        return super.getAllAsync(`app-prices/?filter[apps]=${appId}`);

    }

    /**
    * @ngdoc function
    * @name rest.services.AppPricesRestService#getByAppIdAndCurrency
    * @methodOf rest.services.AppPricesRestService
    * @function
    *
    * @description
    * Retrieves product prices with specified currency.
    *
    * @returns {Promise} The promise of the call.
    */
    getByAppIdAndCurrency(appId, currency) {

        return super.getAllAsync(`app-prices/?filter[apps]=${appId}${currency ? `&filter[currency]=${currency}` : ''}`);

    }

    /**
    * @ngdoc function
    * @name rest.services.AppPricesRestService#getByAppIdAndRuntime
    * @methodOf rest.services.AppPricesRestService
    * @function
    *
    * @description
    * Retrieves product prices for a specific runtime.
    *
    * @returns {Promise} The promise of the call.
    */
    getByAppIdAndRuntime(appId, runtime) {

        return super.getAllAsync(`app-prices/?filter[apps]=${appId}&filter[runtimes]=${runtime}`);

    }

    getByAppIdAndRuntimeAndNumberOfUsers(appId, runtime, numberOfUsers) {

        return super.getAllAsync(`app-prices/?filter[apps]=${appId}&filter[runtimes]=${runtime}&filter[users]=${numberOfUsers}`);

    }

    /**
    * @ngdoc function
    * @name rest.services.AppPricesRestService#getByAppIdAndRuntimeAndCurrency
    * @methodOf rest.services.AppPricesRestService
    * @function
    *
    * @description
    * Retrieves product prices for a specific runtime with specified currency.
    *
    * @returns {Promise} The promise of the call.
    */
    getByAppIdAndRuntimeAndCurrency(appId, runtime, currency) {

        return super.getAllAsync(`app-prices/?filter[apps]=${appId}&filter[runtimes]=${runtime}${currency ? `&filter[currency]=${currency}` : ''}`);

    }

    /**
    * @ngdoc function
    * @name rest.services.AppPricesRestService#getByAppIdAndNumberOfUsers
    * @methodOf rest.services.AppPricesRestService
    * @function
    *
    * @description
    * Retrieves product prices based on users.
    *
    * @returns {Promise} The promise of the call.
    */
    getByAppIdAndNumberOfUsers(appId, numberOfUsers) {

        return super.getAllAsync(`app-prices/?filter[apps]=${appId}&filter[users]=${numberOfUsers}`);

    }

    /**
    * @ngdoc function
    * @name rest.services.AppPricesRestService#getByAppIdAndNumberOfUsersAndRuntime
    * @methodOf rest.services.AppPricesRestService
    * @function
    *
    * @description
    * Retrieves product prices based on users.
    *
    * @returns {Promise} The promise of the call.
    */
    getByAppIdAndNumberOfUsersAndRuntime(appId, numberOfUsers, runtime, currency) {

        return super.getAllAsync(`app-prices/?filter[apps]=${appId}&filter[users]=${numberOfUsers}&filter[runtimes]=${runtime}${currency ? `&filter[currency]=${currency}` : ''}`);

    }

    /**
    * @ngdoc function
    * @name rest.services.AppPricesRestService#getAllAsync
    * @methodOf rest.services.AppPricesRestService
    * @function
    *
    * @description
    * Retrieves all product prices defined in config.
    *
    * @returns {Promise} The promise of the call.
    */
    getAllAsync() {

        const productsArr = CWCONFIG.store.products;
        const businessProductsArr = CWCONFIG.store.businessProducts;
        const bundlesArr = CWCONFIG.store.bundles;
        const productsList = `${productsArr.join()},${bundlesArr.join()},${businessProductsArr.join()},aps20,aps50,adwp1,ispm0`;

        return super.getAllAsync(`app-prices/?filter[apps]=${productsList}&filter[users]=1,3,5,25&filter[runtimes]=1,12,24,36`);

    }

}

_serviceDependencies.push(AppPricesRestService);

angular.module('rest.services')
    .service('AppPricesRestService', _serviceDependencies);




// WEBPACK FOOTER //
// ./scripts/restServices/appPricesRestService.js